import { render, staticRenderFns } from "./CannedNotesList.vue?vue&type=template&id=f70fa086"
import script from "./CannedNotesList.vue?vue&type=script&lang=js"
export * from "./CannedNotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports